<script>
var StudentUserId='';
var EnglishName='';
var CashType = true;
var AUDIOOutputOK = false;
var AUDIOInputOK = false;
var VideoOK = false;
var NetOK = false;
var selectedAudioOutput = "";
var selectedAudioOutput = "";
var selectedCamera = "";
var UploadSpeed=0;
var DownloadSpeed=0;
var Ping=0;

export default{
    StudentUserId,EnglishName,CashType,AUDIOOutputOK,AUDIOInputOK,VideoOK,NetOK,selectedAudioOutput,selectedAudioOutput,selectedCamera,UploadSpeed,DownloadSpeed,Ping
}
</script>



// WEBPACK FOOTER //
// src/components/Global.vue